import { CONFIG } from '../config';

const API_KEY = ''; // Đưa vào config sau
const MODEL = 'gemini-2.5-flash';

export async function sendAI(text: string): Promise<string> {
  const response = await fetch(
    `https://generativelanguage.googleapis.com/v1beta/models/${MODEL}:generateContent?key=${API_KEY}`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        contents: [
          {
            parts: [
              {
                text,
              },
            ],
          },
        ],
      }),
    }
  );

  if (!response.ok) {
    throw new Error(await response.text());
  }

  const result = await response.json();

  return (
    result.candidates?.[0]?.content?.parts?.[0]?.text ??
    'Xin lỗi, tôi không thể trả lời lúc này.'
  );
}

export interface CheckMenuAccessResponse {
    allowed: boolean;
    menuId?: string;
    path?: string;
    roleName?: string;
}

export async function checkMenuAccess(
    path: string
): Promise<CheckMenuAccessResponse> {

    const token =
        localStorage.getItem('accessToken');
    const roleName =
        localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user') || '{}').currentRole : null;

    const response = await fetch(
        `${CONFIG.API_BASE_URL}/api/app/menu-role/check-menu-access`,
        {
            method: 'POST',

            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
                'deviceid': 'fb2e3a7e-63bc-43d1-8bd9-3a215bb5644a',
                'X-Client-Type': 'Blazor',
            },

            body: JSON.stringify({
                path: path,
                roleName: roleName
            })
        }
    );

    if (!response.ok) {
        throw new Error(
            `Check menu access failed: ${response.status}`
        );
    }

    return await response.json();
}
export async function Pong(
    path: string
): Promise<boolean> {

    const token =
        localStorage.getItem('accessToken');
    const roleName =
        localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user') || '{}').currentRole : null;

    const response = await fetch(
        `${CONFIG.API_BASE_URL}/api/app/asset-pickup-schedule/ping`,
        {
            method: 'GET',

            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
                'deviceid': 'fb2e3a7e-63bc-43d1-8bd9-3a215bb5644a',
                'X-Client-Type': 'Blazor',
            },

            // body: JSON.stringify({
            //     path: path,
            //     roleName: roleName
            // })
        }
    );

    // if (!response.ok) {
    //     throw new Error(
    //         `Check menu access failed: ${response.status}`
    //     );
    // }

    //return await response.json();
    return true;
}